module.exports = __webpack_public_path__ + "img/us(5).7e3905a4.jpg";